/* Maison Batu — Phase V, „Arc of Passage"
   Der Blick aus einem orientalischen Raum durch ein offenes Fenster auf den Nil.

   AUFBAU IN EINEM SATZ
   Der Raum und die Landschaft stehen als EIN statisches Bild hinter dem Canvas;
   gezeichnet wird je Bild nur die Fensteroeffnung, und darin nur das, was sich
   wirklich bewegt: die sinkende Sonne, ihre Lichtsaeule, drei Boote mit ihren
   Spiegelungen und die Lichtbaender auf dem Wasser.

   WAS SICH NICHT BEWEGT, UND WARUM
   Das Wasser wird NICHT seitlich durchgeschoben. Ein gleichmaessiger Schub
   liest sich als Foerderband, und eine zeilenweise versetzte Spiegelung sieht
   aus wie gewelltes Papier — beide Anforderungen, als Welle lesbar und ohne
   Kanten, sind in derselben Operation nicht erfuellbar (Phase I, Sackgasse B6).
   Getrennt geht es: die Spiegelung ist EINE glatte gestuerzte Kopie, und die
   Bewegung ist eine EIGENE Schicht, die nur Helligkeit moduliert. Auf echtem
   Wasser wandert ohnehin nicht die Oberflaeche, sondern das Glitzern.

   REIHENFOLGE JE BILD
     1  Grundplatte, Ausschnitt der Oeffnung   (loescht das vorige Bild)
     2  Sonne mit Brandsaum und Hof
     3  Deckplatte „vorn" — Ufer und Wasser zurueck UEBER die Sonne
     4  Lichtsaeule auf dem Wasser
     5  Spiegelungen der Boote
     6  Lichtbaender
     7  die Boote
     8  Deckplatte „rahmen" — der Raum zurueck ueber alles, was ueberlief
*/
(function () {
  'use strict';

  // Die Debugkontrakte stehen VOR dem Ladeblock. Liegen die Platten schon im
  // Zwischenspeicher, meldet das Laden synchron zurueck und es wird gezeichnet,
  // bevor der Rest der Datei ausgefuehrt ist — dann waere window.__arc noch
  // undefined. Der Fehler zeigt sich nur bei WARMEM Cache; die Pruefwerkzeuge
  // legen jedes Mal ein frisches Chrome-Profil an und haetten ihn nie gezeigt
  // (Sackgasse F10).
  window.__arc = { t: 0, p: 0, w: 0, h: 0, dpr: 1 };
  // n / summe / max ist der Vertrag, den tools/tempo.mjs erwartet; mp ist die
  // Flaeche je Bild in Megapunkten und die aussagekraeftigere Zahl (F13).
  window.__arcTempo = { n: 0, summe: 0, max: 0, mp: 0 };

  var P = new URLSearchParams(location.search);
  var zahl = function (k, v) { return P.has(k) ? Number(P.get(k)) : v; };

  // ------------------------------------------------------------------ Regler
  var SONNE_DAUER   = zahl('sonne', 13);    // Sekunden bis die Sonne verschwunden ist
  var SONNE_X_ANT   = zahl('sonnex', 0.47); // Lage im Fenster beim Aufgang
  var SONNE_ZUG     = zahl('zug', 0.15);    // wieviel sie dabei nach links zieht
  var SONNE_R_ANT   = zahl('sonner', 0.030);
  var SONNE_HOCH    = zahl('hoch', 7.4);    // Startpunkt, in Sonnenradien ueber der Baumlinie
  var SONNE_TIEF    = zahl('tief', 2.8);    // Endpunkt, in Radien UNTER der Baumlinie — sie geht ganz unter
  var GLANZ         = zahl('glanz', 0.46);  // Staerke der Glanzstriche
  var STROM         = zahl('strom', 26);    // Zug nach rechts, Plattenpunkte je Sekunde
  var SAEULE_ST     = zahl('saeule', 0.16);
  var DAEMMERUNG    = zahl('daem', 1.22);  // dunkleres, deutlich oranges Abendlicht
  // Schon der Anfang steht etwas unter vollem Tageslicht. Der Raum ist ein
  // Innenraum am spaeten Nachmittag, nicht heller Mittag — und die Daemmerung
  // hat dadurch weniger Weg zu gehen, was den Uebergang ruhiger macht.
  var START_DUNKEL  = zahl('start', 0.12);
  var BOOT_DUNKEL   = zahl('dunkel', 0.34); // Rumpf im Gegenlicht
  var SEGEL_DURCH   = zahl('segel', 1.15);  // das Segel laesst Licht durch
  var SPIEGEL_ST    = zahl('spiegel', 0.30);
  var MAX_MP        = zahl('mp', 1.6);      // Obergrenze an Bildpunkten je Bild
  var FUNKE_AB      = zahl('funke', 9);     // Sekunde, in der der Funke faellt

  // Drei Boote. „unterschiedliche Ebenen, also unterschiedliche Hoehe im
  // Wasser": tiefe = 0 dicht am Ufer, 1 unmittelbar vor dem Betrachter.
  // Nah zieht schnell, fern kaum — daher die Parallaxe.
  var BOOTE = [
    { platte: 2, richtung: +1, tiefe: 0.74, breite: 0.190, dauer: 44, phase: 0.00 },
    { platte: 0, richtung: -1, tiefe: 0.40, breite: 0.125, dauer: 52, phase: 0.42 },
    { platte: 1, richtung: +1, tiefe: 0.15, breite: 0.078, dauer: 68, phase: 0.71 }
  ];

  // ---------------------------------------------------------------- Werkzeug
  var glatt = function (a, b, x) {
    var t = (x - a) / (b - a);
    t = t < 0 ? 0 : t > 1 ? 1 : t;
    return t * t * (3 - 2 * t);
  };
  var misch = function (a, b, t) { return a + (b - a) * t; };

  var ZU_LIN = new Float32Array(256);
  for (var v = 0; v < 256; v++) {
    var s = v / 255;
    ZU_LIN[v] = s <= 0.04045 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
  }
  var zuSrgb = function (x) {
    x = x < 0 ? 0 : x > 1 ? 1 : x;
    var s = x <= 0.0031308 ? x * 12.92 : 1.055 * Math.pow(x, 1 / 2.4) - 0.055;
    return Math.round(s * 255);
  };

  // ------------------------------------------------------------------ Bilder
  var bild = function (src) {
    return new Promise(function (fertig, schief) {
      var i = new Image();
      i.decoding = 'async';
      i.onload = function () { fertig(i); };
      i.onerror = function () { schief(new Error('Bild fehlt: ' + src)); };
      i.src = src;
    });
  };

  // WOHER DIE PLATTEN KOMMEN.
  // Lokal aus dem Vorschauordner. In Shopify liegen sie unter assets/ hinter
  // der CDN-Adresse, die erst Liquid kennt — die Section setzt dafuer
  // window.MB_FENSTER, bevor diese Datei laeuft. Was dort nicht gesetzt ist,
  // faellt auf den lokalen Pfad zurueck. Dadurch laeuft an beiden Orten
  // dieselbe Datei, ohne eine einzige Zeile Unterschied.
  var STD = {
    daten:  'bilder/platten.json',
    vorn:   'bilder/mb-fenster-vorn.webp',
    rahmen: 'bilder/mb-fenster-rahmen.webp',
    lampe:  'bilder/mb-fenster-lampe.webp',
    boot1:  'bilder/mb-fenster-boot1.png',
    boot2:  'bilder/mb-fenster-boot2.png',
    boot3:  'bilder/mb-fenster-boot3.png'
  };
  var Q = window.MB_FENSTER || {};
  for (var sk in STD) if (!Q[sk]) Q[sk] = STD[sk];

  // Gesucht wird ueber data-Merkmale INNERHALB des Abschnitts, nicht ueber
  // feste ids. Eine Shopify-Section kann mehrfach auf einer Seite stehen;
  // feste ids waeren dann doppelt vergeben, und der zweite Abschnitt bekaeme
  // die Elemente des ersten.
  var abschnitt = document.querySelector('[data-mb-passage]');
  if (!abschnitt) return;
  if (P.has('motion')) abschnitt.classList.add('mb-passage--force-motion');
  var hol = function (n) { return abschnitt.querySelector('[data-mb-' + n + ']'); };
  // In der Shopify-Seite folgt unter der Animation noch der Karten- und
  // Waitlist-Bereich. Deshalb darf die Laufzeit nur die eigentliche Szene
  // hoehensteuern, nicht den gesamten Abschnitt abschneiden.
  var szene      = hol('scene') || abschnitt;
  var buehne    = hol('buehne');
  var grundImg  = hol('grund');
  var leinwand  = hol('arc-canvas');
  var textBlock = hol('text');
  var daemEl    = hol('daemmerung');
  var lampeEl   = hol('lampe');
  var kernEl    = hol('lampenkern');
  var kuehlEl   = hol('kuehl');
  var raumEl    = hol('raum');
  if (!buehne || !grundImg || !leinwand || !textBlock) return;
  var ctx = leinwand.getContext('2d', { alpha: true });
  var rctx = raumEl ? raumEl.getContext('2d', { alpha: true }) : null;

  // Der Raumstreifen: Lichtschaft auf dem Boden und die Laterne darueber.
  // Gemessen am Raumbild liegt der helle Schaft bei x 250…750, y 1120…1400.
  // Enger geschnitten und feiner aufgeloest als zuvor. Bei halber Aufloesung
  // waren die Staubkoerner zwangslaeufig grob; jetzt 0,7, und der Streifen
  // deckt nur noch Laterne und Tisch ab statt der ganzen Raumhoehe.
  var RAUM = { x: 140, y: 110, w: 512, h: 1252, sk: 0.7 };
  // Gemessen am Raumbild: die Kanne steht bei x 240…313, y 1020…1127, die
  // Tischplatte bei x 193…380, y 1117…1153, der Fuss reicht bis y 1290.
  // Dort faellt das Licht ein, und dort gehoert der Staub hin.
  var SCHAFT = { x0: 152, x1: 468, y0: 950, y1: 1338 };

  var D = null, vorn = null, rahmen = null, bootPlatten = [];
  var G = null;                    // Geometrie, siehe rechneGeometrie()
  var boote = [];                  // vorgerechnete Bootsbilder
  var laeuft = false, t0 = 0, angehalten = null;
  var kartenTimer = null;

  function zeigeKarten() {
    if (kartenTimer !== null) {
      clearTimeout(kartenTimer);
      kartenTimer = null;
    }
    abschnitt.classList.add('mb-passage--cards-visible');
  }

  function planeKarten() {
    if (kartenTimer !== null || abschnitt.classList.contains('mb-passage--cards-visible')) return;
    // Die fuenf Sekunden beginnen erst mit dem wirklichen Szenenstart. So
    // laufen sie nicht schon waehrend Bild- und Scriptdateien noch laden.
    kartenTimer = setTimeout(zeigeKarten, 5000);
  }

  var sparsam = false;
  try {
    sparsam = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) { /* alte Browser */ }
  if (P.has('motion')) sparsam = false;
  if (P.has('ruhig'))  sparsam = true;

  // Filmmodus: fuer die Aufnahme fuellt die Buehne das Fenster ganz und der
  // Hinweistext faellt weg. Sonst stuende im Video unten ein schwarzer
  // Streifen und darunter Fliesstext.
  var FILM = P.has('film');

  // ================================================================ Geometrie
  function rechneGeometrie() {
    var pw = D.grund.w, ph = D.grund.h;
    var fw = abschnitt.clientWidth || window.innerWidth;
    // Phase V ist wie die anderen Phasen eine einzige, zusammenhaengende
    // Bildszene. Karten und Waitlist liegen darin; deshalb deckt die originale
    // Platte die komplette (per CSS definierte) Szenenhoehe ab. Keine zweite
    // Bildkopie und kein nachtraeglich angesetzter Hintergrund.
    var fh = szene.clientHeight || window.innerHeight;
    var pv = pw / ph, fv = fw / fh;
    var hoehe = fh;
    // Desktop zeigt die komplette hochformatige Platte (contain): Decke,
    // Laterne, Fensterbank, Tisch und Teekanne bleiben gleichzeitig sichtbar.
    // Mobil bleibt die zusammenhaengende Platte weiterhin randfuellend.
    var sk = fw > 860
      ? Math.min(fw / pw, fh / ph)
      : Math.max(fw / pw, fh / ph);
    var bw = pw * sk, bh = ph * sk;
    var bx = (fw - bw) / 2;
    // Die vollstaendige Desktop-Platte wird mittig in der Szene platziert.
    // Mobil bleibt die bestehende, bereits abgenommene Lage unangetastet.
    var by = fw > 860
      ? (fh - bh) / 2
      : (fh - bh) * 0.48;
    szene.style.height = Math.round(hoehe) + 'px';
    buehne.style.width  = bw + 'px';
    buehne.style.height = bh + 'px';
    buehne.style.transform = 'translate(' + bx + 'px,' + by + 'px)';

    var s = bw / pw;                                   // Platte → CSS-Punkte
    var O = D.oeffnung;
    var fx = bx + O.x0 * s, fy = by + O.y0 * s;
    var fwid = O.w * s, fhig = O.h * s;

    leinwand.style.left   = (O.x0 * s) + 'px';
    leinwand.style.top    = (O.y0 * s) + 'px';
    leinwand.style.width  = fwid + 'px';
    leinwand.style.height = fhig + 'px';

    // Daemmerung und kuehles Abendlicht gelten ausschliesslich fuer den Blick
    // nach draussen. Der Raum selbst bleibt warm und die Laterne lesbar.
    [daemEl, kuehlEl].forEach(function (el) {
      if (!el) return;
      el.style.left = (O.x0 * s) + 'px';
      el.style.top = (O.y0 * s) + 'px';
      el.style.width = fwid + 'px';
      el.style.height = fhig + 'px';
    });

    // Obergrenze an Bildpunkten statt festem dpr-Deckel: grosse Fenster
    // bekommen ein niedrigeres Verhaeltnis, kleine behalten die volle Schaerfe.
    var dpr = window.devicePixelRatio || 1;
    var mp = (fwid * dpr) * (fhig * dpr) / 1e6;
    if (mp > MAX_MP) dpr *= Math.sqrt(MAX_MP / mp);
    var cw = Math.max(2, Math.round(fwid * dpr)), ch = Math.max(2, Math.round(fhig * dpr));
    leinwand.width = cw; leinwand.height = ch;

    // Der Textblock haengt an der BUEHNE, nicht am Fenster. Bei der Tafel sind
    // das zwei verschiedene Dinge; ein an vw gebundener Titel stuende sonst zur
    // Haelfte auf dem schwarzen Grund daneben.
    abschnitt.style.setProperty('--mb-buehne-x', bx + 'px');
    abschnitt.style.setProperty('--mb-buehne-y', by + 'px');
    abschnitt.style.setProperty('--mb-buehne-w', bw + 'px');
    abschnitt.style.setProperty('--mb-buehne-h', bh + 'px');
    textBlock.style.top = Math.round(hoehe * 0.055) + 'px';

    G = {
      pw: pw, ph: ph, s: s, dpr: dpr, cw: cw, ch: ch,
      O: O, k: cw / O.w,                    // Plattenpunkte → Canvaspunkte
      bx: bx, by: by, bw: bw, bh: bh, hoehe: hoehe,
      tafel: fv > pv * 1.25
    };
    // Vertrag der Werkzeuge: w und h sind das CANVASMASS, nicht das Fenster.
    // Genau darum geht es hier — der Canvas ist absichtlich viel kleiner als
    // die Buehne, weil sich ausserhalb der Fensteroeffnung nie etwas aendert.
    window.__arc.w = cw;
    window.__arc.h = ch;
    window.__arc.dpr = Math.round(dpr * 100) / 100;
    window.__arc.tafel = G.tafel;
    window.__arc.buehne = { x: Math.round(bx), y: Math.round(by), w: Math.round(bw), h: Math.round(bh) };

    // Die Laterne haengt an der Buehne, ihre Lage steht in platten.json.
    if (D.lampe) {
      // Der Hof sitzt etwas TIEFER als die Mitte der Laterne: das Licht steht
      // im unteren, durchbrochenen Teil, nicht in der Aufhaengung.
      if (lampeEl) {
        var lr = D.lampe.r * s * 2.7;
        lampeEl.style.left   = (D.lampe.x * s - lr) + 'px';
        lampeEl.style.top    = ((D.lampe.y + D.lampe.r * 0.55) * s - lr) + 'px';
        lampeEl.style.width  = (lr * 2) + 'px';
        lampeEl.style.height = (lr * 2) + 'px';
      }
      // Der Kern liegt genau auf dem Kasten, aus dem die Platte geschnitten ist.
      if (kernEl && D.lampe.kw) {
        kernEl.style.left   = (D.lampe.kx * s) + 'px';
        kernEl.style.top    = (D.lampe.ky * s) + 'px';
        kernEl.style.width  = (D.lampe.kw * s) + 'px';
        kernEl.style.height = (D.lampe.kh * s) + 'px';
        kernEl.style.backgroundImage = "url('" + Q.lampe + "')";
      }
    }

    // Der Raumcanvas mit halber Aufloesung. Staub und Funken sind weich; ein
    // schaerferer Raster brächte nichts und kostete die vierfache Flaeche.
    if (raumEl) {
      raumEl.style.left   = (RAUM.x * s) + 'px';
      raumEl.style.top    = (RAUM.y * s) + 'px';
      raumEl.style.width  = (RAUM.w * s) + 'px';
      raumEl.style.height = (RAUM.h * s) + 'px';
      raumEl.width  = Math.max(2, Math.round(RAUM.w * s * G.dpr * RAUM.sk));
      raumEl.height = Math.max(2, Math.round(RAUM.h * s * G.dpr * RAUM.sk));
      G.rk = raumEl.width / RAUM.w;              // Plattenpunkte → Raumcanvas
    }

    rechneBoote();
    bauGlanz();
    SONNE_BASIS = null;
    bauSterne();
    bauSchaft();
    if (!KORN) bauKorn();
  }

  // Plattenkoordinaten → Canvaskoordinaten
  function cx(x) { return (x - G.O.x0) * G.k; }
  function cy(y) { return (y - G.O.y0) * G.k; }

  // Wasserlinie und Baumlinie sind je SPALTE der Oeffnung abgelegt, in
  // Plattenkoordinaten. Die Uferlinie ist nicht gerade: das Ufer springt rechts
  // vor, weil die Bucht dort naeher steht. Gemessen ueber die Spiegelsymmetrie
  // zwischen Ufer und seiner gemalten Spiegelung — die dunkelste Zeile taugt
  // dafuer nicht, sie wandert mit dem, was am Ufer steht.
  function wasserBei(xPlatte) {
    var i = Math.round(xPlatte - G.O.x0);
    if (i < 0) i = 0; else if (i >= D.wasserlinie.length) i = D.wasserlinie.length - 1;
    return D.wasserlinie[i];
  }
  function baumBei(xPlatte) {
    var i = Math.round(xPlatte - G.O.x0);
    if (i < 0) i = 0; else if (i >= D.baumlinie.length) i = D.baumlinie.length - 1;
    return D.baumlinie[i];
  }

  // ================================================== Boote einmal vorrechnen
  // Die Beleuchtung wird NICHT je Bild gerechnet, sondern einmal je Groesse in
  // ein eigenes Bild gebrannt. Jedes Boot hat eine feste Tiefe und damit eine
  // feste Groesse — es gibt also nichts, was sich je Bild aendern muesste.
  // Je Bild bleibt ein einziges drawImage.
  function rechneBoote() {
    boote = BOOTE.map(function (b) {
      var q = bootPlatten[b.platte];
      var dw = Math.max(4, Math.round(G.O.w * b.breite * G.k));
      var dh = Math.max(4, Math.round(dw * q.height / q.width));

      // Schritt 1: die Platte auf Zielgroesse bringen
      var roh = document.createElement('canvas');
      roh.width = dw; roh.height = dh;
      var rc = roh.getContext('2d');
      rc.drawImage(q, 0, 0, dw, dh);
      var dat = rc.getImageData(0, 0, dw, dh);
      var a = dat.data;

      // Schritt 2: Gegenlicht rechnen.
      // Geliefert wurden die Boote gleichmaessig ausgeleuchtet. Gegen eine tief
      // stehende Sonne muessen sie dunkel stehen — aber nicht gleichmaessig
      // dunkel: der Rumpf ist undurchsichtig und wird zur Silhouette, das Segel
      // ist duennes Tuch und LEUCHTET, weil das Licht hindurchgeht. Der
      // Unterschied haengt an der eigenen Helligkeit der Platte, und genau
      // daran wird er festgemacht.
      for (var i = 0; i < a.length; i += 4) {
        if (a[i + 3] === 0) continue;
        var r = ZU_LIN[a[i]], g = ZU_LIN[a[i + 1]], bl = ZU_LIN[a[i + 2]];
        var lum = 0.2126 * r + 0.7152 * g + 0.0722 * bl;
        var f = misch(BOOT_DUNKEL, SEGEL_DURCH, glatt(0.16, 0.62, lum));
        var warm = (f - BOOT_DUNKEL) * 0.30;
        a[i]     = zuSrgb(r * f + 1.00 * warm);
        a[i + 1] = zuSrgb(g * f + 0.58 * warm);
        a[i + 2] = zuSrgb(bl * f + 0.24 * warm);
      }
      rc.putImageData(dat, 0, 0);

      // Schritt 3: die Spiegelung. Eine gestuerzte Kopie, um 1,06 in die Laenge
      // gezogen — auf bewegtem Wasser ist eine Spiegelung immer laenger als das
      // Original, weil geneigte Wellenflaechen zusaetzliche Blickwinkel
      // liefern. Nach unten schwaecher: nahe am Betrachter trifft der Blick
      // steiler auf, dort reflektiert Wasser weniger.
      var sh = Math.round(dh * 1.06);
      var sp = document.createElement('canvas');
      sp.width = dw; sp.height = sh;
      var sc = sp.getContext('2d');
      sc.save();
      sc.translate(0, sh);
      sc.scale(1, -sh / dh);
      sc.drawImage(roh, 0, 0);
      sc.restore();
      var sd = sc.getImageData(0, 0, dw, sh), sa = sd.data;
      for (var y = 0; y < sh; y++) {
        var vv = y / sh;
        var d = SPIEGEL_ST * (1 - 0.78 * vv);
        for (var x = 0; x < dw; x++) {
          var j = (y * dw + x) * 4 + 3;
          sa[j] = Math.round(sa[j] * d);
        }
      }
      sc.putImageData(sd, 0, 0);

      return { def: b, bild: roh, spiegel: sp, dw: dw, dh: dh, sh: sh };
    });
    // Nach TIEFE sortiert, fern zuerst. Vorher wurde in der Reihenfolge der
    // Liste gezeichnet, und das nahe Boot lag damit HINTER den ferneren —
    // beim Kreuzen schoben sie sich ineinander. Ein Gegenstand vor mir
    // verdeckt einen dahinter, nicht umgekehrt.
    boote.sort(function (a, b) { return a.def.tiefe - b.def.tiefe; });
  }

  // ==================================================================== Sonne
  // Feste Bezugshoehe fuer die Sonnenbahn.
  //
  // Vorher wurde sie je Bild aus der Baumlinie der AKTUELLEN Spalte geholt.
  // Solange die Sonne senkrecht fiel, war das eine feste Zahl. Seit sie im
  // Bogen nach links zieht, wandert sie ueber einen gezackten Palmensaum — und
  // die Bezugshoehe sprang mit: gemessen Schritte von 0 bis 13 Bildpunkten
  // statt gleichmaessiger 2,1, teils sogar rueckwaerts. Das war das Ruckeln.
  //
  // Die Bahn eines Himmelskoerpers hat mit der Form des Ufers nichts zu tun.
  // Genommen wird deshalb das Mittel der Baumlinie ueber die ganze Strecke,
  // die die Sonne zuruecklegt — einmal gerechnet und dann fest.
  var SONNE_BASIS = null;
  function sonneBasis() {
    if (SONNE_BASIS !== null) return SONNE_BASIS;
    var xa = G.O.x0 + G.O.w * (SONNE_X_ANT - SONNE_ZUG);
    var xb = G.O.x0 + G.O.w * SONNE_X_ANT;
    var s = 0, k = 0;
    for (var x = Math.round(xa); x <= Math.round(xb); x++) { s += baumBei(x); k++; }
    SONNE_BASIS = k ? s / k : baumBei(xb);
    return SONNE_BASIS;
  }

  function sonneStand(t) {
    // Ein Sonnenuntergang als ganz langsamer Ablauf: die Sonne sinkt EINMAL und
    // bleibt dann stehen. Sie laeuft nicht im Kreis — ein Ablauf, der endlos
    // von vorn beginnt, waere kein Untergang mehr.
    var u = Math.min(1, t / SONNE_DAUER);
    // Sie faellt nicht senkrecht, sondern zieht dabei nach links — eine
    // untergehende Sonne laeuft schraeg auf den Horizont zu, nicht lotrecht.
    // Der Bogen folgt damit ungefaehr der Kurve des Fensterbogens.
    //
    // Seitlich mit u^1.3: anfangs kaum, spaeter deutlich. Das ist die
    // Projektion einer schraegen Bahn auf die Bildebene, und es haelt die
    // Sonne oben in der Mitte des Fensters statt sie sofort auszuwandern.
    var xs = G.O.x0 + G.O.w * (SONNE_X_ANT - SONNE_ZUG * Math.pow(u, 1.3));
    var r  = G.O.w * SONNE_R_ANT;
    var basis = sonneBasis();
    var y = basis - r * SONNE_HOCH + (SONNE_HOCH + SONNE_TIEF) * r * u;
    // Rayleigh: tief stehendes Licht laeuft durch viel mehr Atmosphaere, der
    // blaue Anteil wird weggestreut. Hoch am Himmel fast weiss, unten orange.
    var w = u * u;
    return {
      x: xs, y: y, r: r, u: u,
      farbe: [1.0, misch(0.80, 0.50, w), misch(0.55, 0.16, w)]
    };
  }

  function zeichneSonne(S) {
    var x = cx(S.x), y = cy(S.y), r = S.r * G.k;
    var f = S.farbe;
    var rgb = function (m) {
      return 'rgba(' + Math.round(255 * Math.min(1, f[0] * m)) + ',' +
                       Math.round(255 * Math.min(1, f[1] * m)) + ',' +
                       Math.round(255 * Math.min(1, f[2] * m)) + ',';
    };
    ctx.save();
    ctx.globalCompositeOperation = 'lighter';

    // Hof
    var hof = ctx.createRadialGradient(x, y, r * 0.4, x, y, r * 9);
    hof.addColorStop(0,    rgb(1) + '0.42)');
    hof.addColorStop(0.22, rgb(1) + '0.16)');
    hof.addColorStop(1,    rgb(1) + '0)');
    ctx.fillStyle = hof;
    ctx.fillRect(x - r * 9, y - r * 9, r * 18, r * 18);

    // Die Scheibe. Der Verlauf ist ZENTRIERT und bis 0,70 praktisch
    // unveraendert hell, danach faellt er schnell ab — dazu ein enger
    // Brandsaum, der die Scheibe ins Umfeld ausbrennen laesst. Ein
    // gleichmaessiger Verlauf mit versetztem Zentrum waere die Zeichnung einer
    // von aussen beleuchteten Kugel; eine Sonne ist eine Lichtquelle und
    // ueberstrahlt (Phase I, Fassung 8).
    var k = ctx.createRadialGradient(x, y, 0, x, y, r * 1.5);
    k.addColorStop(0,    'rgba(255,252,242,1)');
    k.addColorStop(0.55, rgb(1) + '0.98)');
    k.addColorStop(0.68, rgb(1) + '0.92)');
    k.addColorStop(0.78, rgb(0.9) + '0.42)');
    k.addColorStop(1,    rgb(0.8) + '0)');
    ctx.fillStyle = k;
    ctx.fillRect(x - r * 1.5, y - r * 1.5, r * 3, r * 3);
    ctx.restore();
  }

  // ============================================================= Lichtsaeule
  function zeichneSaeule(S, t) {
    // Steht ein Koerper tief, ist seine Spiegelung keine Scheibe, sondern eine
    // lange Saeule, die auf den Betrachter zulaeuft — das ist die Verteilung
    // der Wellenneigungen. Sie wandert mit der Sonne mit; genau deshalb durfte
    // sie nicht in der Platte stecken.
    //
    // Sie ist jetzt ein WEICHER Keil ohne eigenes Zittern. Vorher hatte sie ein
    // eingebautes Flackern, und weil ihre Lage und Form dabei fest blieben, las
    // sich das als etwas, das an derselben Stelle zappelt. Die Bewegung kommt
    // stattdessen von den Glanzstrichen, die ueber sie hinwegziehen — dieselbe
    // Stroemung wie auf dem uebrigen Wasser, nur heller.
    var oben = wasserBei(S.x);
    var unten = G.O.y1;
    // Mit der Sonne verschwinden. Sie sinkt bis hinter den Palmensaum; steht
    // sie dort, gibt es nichts mehr, was sich auf dem Wasser spiegeln koennte.
    // Ueberblendet ueber gut zwei Sonnenradien, damit die Saeule nicht in
    // einem einzigen Bild wegspringt (Sackgasse B3).
    var bl = sonneBasis();
    var ab = 1 - glatt(bl - S.r * 0.2, bl + S.r * 2.2, S.y);
    if (ab <= 0.01) return;
    var f = S.farbe;
    var schritte = 26;
    ctx.save();
    ctx.globalCompositeOperation = 'lighter';
    for (var i = 0; i < schritte; i++) {
      var tf = i / (schritte - 1);                     // 0 fern … 1 nah
      var y = oben + tf * (unten - oben);
      var br = S.r * (0.42 + 6.4 * tf);
      var st = SAEULE_ST * ab * (0.30 + 0.70 * Math.exp(-tf * 1.5));
      if (st < 0.004) continue;
      var xm = cx(S.x), yy = cy(y), bb = br * G.k;
      var hoehe = (unten - oben) / (schritte - 1) * G.k + 1;
      var gr = ctx.createLinearGradient(xm - bb, 0, xm + bb, 0);
      var mid = 'rgba(' + Math.round(255 * f[0]) + ',' + Math.round(255 * f[1]) + ',' +
                Math.round(255 * f[2]) + ',';
      gr.addColorStop(0,    mid + '0)');
      gr.addColorStop(0.32, mid + (st * 0.45).toFixed(3) + ')');
      gr.addColorStop(0.5,  mid + st.toFixed(3) + ')');
      gr.addColorStop(0.68, mid + (st * 0.45).toFixed(3) + ')');
      gr.addColorStop(1,    mid + '0)');
      ctx.fillStyle = gr;
      ctx.fillRect(xm - bb, yy, bb * 2, hoehe);
    }
    ctx.restore();
  }

  // ============================================================ Der Glanz
  //
  // Der erste Entwurf legte einen reinen SENKRECHTEN Verlauf ueber das Wasser.
  // Darin kann sich seitlich nichts zeigen — es gab keine waagerechte Struktur,
  // an der eine Stroemung ablesbar waere. Genau deshalb sah das Wasser
  // unbewegt aus, obwohl sich rechnerisch etwas aenderte (Sackgasse B5: an
  // einer strukturlosen Flaeche ist keine Bewegung ablesbar).
  //
  // Jetzt gibt es eine echte Glanzschicht: kurze waagerechte Lichtstriche, die
  // nach RECHTS ziehen. Sie liegt als Textur bereit und wird je Bild in 32
  // Baendern gezeichnet, jedes mit einem eigenen Massstab.
  //
  // Der Massstab ist der Trick. Ein Band in der Tiefe d holt sich einen
  // BREITEREN Ausschnitt der Textur und quetscht ihn auf dieselbe Breite:
  // fern liegen die Glanzstriche dadurch dicht und wandern langsam, nah liegen
  // sie weit auseinander und ziehen schnell. Die Phase ist fuer ALLE Baender
  // dieselbe — deshalb laufen sie nicht mit der Zeit auseinander, und es
  // entsteht keine waagerechte Rissbildung zwischen den Baendern.
  //
  // Verschoben wird damit auch nicht die Wasserplatte selbst. Wuerde man die
  // schieben, zoege es die gemalten Ufersspiegelungen mit — und eine Spiegelung
  // bleibt unter ihrem Gegenstand stehen, auch wenn der Fluss laeuft.
  var glanz = null, glanzTW = 0, glanzTH = 0, wasserObenP = 0;

  function bauGlanz() {
    // Aus platten.json, nicht aus der Wasserlinie. Die ist die SPIEGELACHSE und
    // liegt dort, wo das Ufer im MITTEL endet — rechts springt die Bucht vor,
    // und dort stand der Glanz auf dem Land statt auf dem Wasser.
    wasserObenP = D.glanzOben || 0;
    if (!wasserObenP)
      for (var i = 0; i < D.wasserlinie.length; i++)
        if (D.wasserlinie[i] > wasserObenP) wasserObenP = D.wasserlinie[i];

    var hoehe = Math.max(8, Math.round(cy(G.O.y1) - cy(wasserObenP)));
    glanzTW = Math.max(64, Math.round(G.cw * 6));   // Platz fuer den weitesten Massstab
    glanzTH = hoehe;

    // Ein einzelner weicher Strich, einmal gezeichnet und dann tausendfach
    // gesetzt. Tausend Verlaeufe einzeln anzulegen waere beim Aufbau spuerbar.
    var s = document.createElement('canvas');
    s.width = 64; s.height = 8;
    var sc = s.getContext('2d');
    var sg = sc.createLinearGradient(0, 0, 64, 0);
    sg.addColorStop(0, 'rgba(255,224,178,0)');
    sg.addColorStop(0.5, 'rgba(255,236,205,1)');
    sg.addColorStop(1, 'rgba(255,224,178,0)');
    sc.fillStyle = sg;
    sc.fillRect(0, 0, 64, 8);
    // senkrecht weich auslaufen lassen
    var vg = sc.createLinearGradient(0, 0, 0, 8);
    vg.addColorStop(0, 'rgba(0,0,0,1)');
    vg.addColorStop(0.5, 'rgba(0,0,0,0)');
    vg.addColorStop(1, 'rgba(0,0,0,1)');
    sc.globalCompositeOperation = 'destination-out';
    sc.fillStyle = vg;
    sc.fillRect(0, 0, 64, 8);

    glanz = document.createElement('canvas');
    glanz.width = glanzTW; glanz.height = glanzTH;
    var gc = glanz.getContext('2d');
    gc.clearRect(0, 0, glanzTW, glanzTH);

    // Lage, Laenge und Helligkeit der Striche aus einer Streuwertfolge.
    //
    // Der erste Entwurf nahm dafuer eine additive Folge mit irrationalen
    // Schrittweiten. Die ist gleichverteilt — und damit fast REGELMAESSIG: die
    // Striche standen in nahezu gleichen Abstaenden, und beim Nachmessen fand
    // die Kreuzkorrelation deshalb mehrdeutige Verschiebungen. Gebraucht wird
    // hier keine Gleichverteilung, sondern Unregelmaessigkeit.
    //
    // Ein linearer Kongruenzgenerator kommt trotzdem nicht in Frage, der hat
    // Gitterstruktur (Sackgasse B8).
    var streu = function (a, b) {
      var x = Math.sin(a * 12.9898 + b * 78.233) * 43758.5453;
      return x - Math.floor(x);
    };
    var proZeile = Math.max(8, Math.round(glanzTW / 34));
    var zeilen = Math.max(4, Math.round(glanzTH / 2.2));
    var mass = Math.max(1, G.k * 0.9);
    for (var z = 0; z < zeilen; z++) {
      var yy = z / zeilen * glanzTH;
      for (var k = 0; k < proZeile; k++) {
        var f1 = streu(k, z);
        var f2 = streu(k + 91, z + 17);
        var f3 = streu(k + 233, z + 57);
        var lang = (5 + 19 * f2 * f2) * mass;
        var dick = (1.3 + 2.4 * f3) * mass;
        gc.globalAlpha = 0.34 + 0.66 * f3;
        // modulo glanzTW gesetzt, damit die Textur nahtlos kachelt
        var xx = f1 * glanzTW;
        gc.drawImage(s, xx - lang / 2, yy - dick / 2, lang, dick);
        if (xx - lang / 2 < 0)        gc.drawImage(s, xx - lang / 2 + glanzTW, yy - dick / 2, lang, dick);
        if (xx + lang / 2 > glanzTW)  gc.drawImage(s, xx - lang / 2 - glanzTW, yy - dick / 2, lang, dick);
      }
    }
  }

  var GLANZ_BAENDER = 26;
  var ABSCHNITTE    = 6;   // Abschnitte je Band, fuer die Ballung um die Saeule

  function zeichneGlanz(t, S) {
    if (!glanz) return;
    // Die sparsame Fassung schaltet die Stroemung NICHT ab, sie verlangsamt sie.
    //
    // Der erste Entwurf schaltete sie ab — und damit das Einzige, was das Wasser
    // ueberhaupt bewegt. Unter Windows ist „Animationen anzeigen" haeufig aus,
    // ohne dass es jemandem bewusst ist; der Auftraggeber sah daraufhin ein
    // stehendes Wasser und meldete zu Recht, es bewege sich nichts. Genau diese
    // Falle steht als Sackgasse F9 in den Unterlagen, aus Phase V, wo ihm
    // dasselbe mit der Startseite passiert ist.
    //
    // Sachlich gehoert hier auch nichts abgeschaltet: die Regel zielt auf
    // vestibulaere Ausloeser, also auf grosse, schnelle oder unvorhersehbare
    // Bewegung. Eine gleichmaessige, langsame Stroemung in eine Richtung ist
    // keine davon, und Flackern gibt es seit dem Umbau der Lichtsaeule nicht
    // mehr. Verlangsamt wird sie trotzdem — das kostet nichts und ist gefaellig.
    var st = sparsam ? STROM * 0.45 : STROM;
    var gl = sparsam ? GLANZ * 0.80 : GLANZ;
    var yTop = cy(wasserObenP), yBot = cy(G.O.y1);
    var bandC = (yBot - yTop) / GLANZ_BAENDER;
    var bandT = glanzTH / GLANZ_BAENDER;
    var phase = t * st * G.k;                          // Zug nach rechts
    ctx.save();
    ctx.globalCompositeOperation = 'lighter';
    // Der Glanz ballt sich um die LICHTSAEULE. Gleichmaessig ueber die ganze
    // Flaeche gelegt sah das Wasser aus wie mit Pailletten belegt — und genau
    // das wurde gemeldet. Auf echtem Wasser glitzert es dort, wo die
    // Wellenneigung die Sonne trifft, also in einem Streifen zur Lichtquelle
    // hin; seitlich davon bleibt die Flaeche ruhig.
    //
    // Umgesetzt ueber Abschnitte je Band, jeder mit eigener Deckung. Ein
    // einziges Zeichnen je Band koennte die Deckung nicht ueber die Breite
    // aendern, und eine Maske waere ein Mischmodus mehr.
    var sxm = cx(S.x);
    var sigma = G.cw * 0.34;
    for (var i = 0; i < GLANZ_BAENDER; i++) {
      var d = (i + 0.5) / GLANZ_BAENDER;               // 0 fern … 1 nah
      // Massstab flacher als vorher: bei 1,45 wurden die Striche im nahen Band
      // auf ueber 50 Punkte gestreckt und lasen sich als lange Striche.
      var pf = 0.34 + 0.72 * d * d;
      var srcW = G.cw / pf;
      var sx = (-phase) % glanzTW; if (sx < 0) sx += glanzTW;
      var dy = yTop + i * bandC, sy = i * bandT;
      // Oben EINBLENDEN. Vorher begann der Glanz bei einer festen Zeile mit
      // voller Bandstaerke, und quer durch das Wasser lief eine harte Kante —
      // gemeldet als „Linie, hinter der das Boot verschwindet", und mit
      // ?glanz=0 war sie nachweislich weg.
      var grund = gl * (0.28 + 0.72 * d) * glatt(0, 0.16, d);

      for (var k = 0; k < ABSCHNITTE; k++) {
        var a0 = k / ABSCHNITTE, a1 = (k + 1) / ABSCHNITTE;
        var xm = (a0 + a1) / 2 * G.cw;
        var e = (xm - sxm) / sigma;
        // Bodenwert 0,18: ganz ohne Glitzern ausserhalb der Saeule waere das
        // Wasser dort wieder eine strukturlose Flaeche (Sackgasse B5).
        ctx.globalAlpha = grund * (0.18 + 0.82 * Math.exp(-e * e));
        if (ctx.globalAlpha < 0.004) continue;
        var q0 = sx + a0 * srcW, qw = (a1 - a0) * srcW;
        // Quelle umlaufen lassen; die Textur kachelt nahtlos
        var q = q0 % glanzTW; if (q < 0) q += glanzTW;
        var rest = glanzTW - q;
        var dx0 = a0 * G.cw, dxw = (a1 - a0) * G.cw;
        if (rest >= qw) {
          ctx.drawImage(glanz, q, sy, qw, bandT, dx0, dy, dxw + 0.5, bandC + 0.6);
        } else {
          var t1 = rest / qw;
          ctx.drawImage(glanz, q, sy, rest, bandT, dx0, dy, dxw * t1 + 0.5, bandC + 0.6);
          ctx.drawImage(glanz, 0, sy, qw - rest, bandT, dx0 + dxw * t1, dy, dxw * (1 - t1) + 0.5, bandC + 0.6);
        }
      }
    }
    ctx.restore();
  }

  // ================================================================== Boote
  function bootLage(b, t) {
    var d = b.def;
    // Der Weg reicht ueber beide Fensterkanten hinaus: das Boot kommt hinter
    // dem Rahmen hervor und verschwindet dahinter, es taucht nicht auf.
    // Der Weg muss die SPUR mit aufnehmen. Vorher endete er kurz hinter dem
    // Boot, und beim Zuruecksetzen sprang eine noch sichtbare Spur weg.
    // Nur die AUSFAHRT muss die Spur mit aufnehmen. Symmetrisch gerechnet
    // stand das Boot zwei Drittel der Zeit ausserhalb des Fensters, und auf
    // dem Bild wirkte es dadurch gehetzt.
    var ein = (b.dw / G.k) + 8;
    var aus = ((b.dw + b.dw * 5.5) / G.k) + 8;
    var von = b.def.richtung > 0 ? G.O.x0 - ein : G.O.x0 - aus;
    var bis = b.def.richtung > 0 ? G.O.x1 + aus : G.O.x1 + ein;
    var u = ((t / d.dauer) + d.phase) % 1;
    if (u < 0) u += 1;
    var x = d.richtung > 0 ? misch(von, bis, u) : misch(bis, von, u);
    var w = wasserBei(x);
    var y = w + d.tiefe * (G.O.y1 - w);      // Wasserlinie DES BOOTES
    return { x: x, y: y };
  }

  function zeichneBoot(b, t, mitSpiegel) {
    var L = bootLage(b, t);
    var xm = cx(L.x), ym = cy(L.y);
    ctx.save();
    if (b.def.richtung < 0) { ctx.translate(xm, 0); ctx.scale(-1, 1); ctx.translate(-xm, 0); }
    if (mitSpiegel) ctx.drawImage(b.spiegel, xm - b.dw / 2, ym);
    else            ctx.drawImage(b.bild,    xm - b.dw / 2, ym - b.dh);
    ctx.restore();
  }

  // ============================================================== Daemmerung
  // Sobald die Sonne hinter dem Saum steht, geht die Laterne an und alles wird
  // etwas dunkler und waermer. Multiplikativ: der Himmel verliert dabei mehr
  // Blau als Rot und wird dadurch oranger, ohne dass eine zweite Platte noetig
  // waere. Additiv abzuziehen wuerde die Farbe kippen (Sackgasse A4).
  //
  // Geschrieben wird nur, wenn sich der Wert merklich aendert — sonst waeren es
  // zwei Stiländerungen je Bild fuer nichts.
  var daemAlt = -1;
  function setzeDaemmerung(d) {
    if (Math.abs(d - daemAlt) < 0.004) return;
    daemAlt = d;
    if (daemEl) {
      var k = (START_DUNKEL + (1 - START_DUNKEL) * d) * DAEMMERUNG;
      // Deutlich oranger als zuvor: der Blauanteil faellt fast doppelt so
      // stark wie der Rotanteil, und genau daran liest sich Abendlicht.
      var r = Math.round(misch(255, 170, k));
      var g = Math.round(misch(255, 114, k));
      var b = Math.round(misch(255,  78, k));
      daemEl.style.background = 'rgb(' + r + ',' + g + ',' + b + ')';
    }
    // Der graue Einschlag. Multiplizieren allein macht nur dunkler und
    // waermer; abends fuellt das Himmelslicht die Schatten aber mit kaltem
    // Licht auf. Sehr schwach additiv, sonst wird daraus Dunst.
    // Der kuehle Anteil bleibt an der echten Daemmerung: der Anfang soll
    // dunkler sein, aber nicht schon blaeulich.
    if (kuehlEl) kuehlEl.style.opacity = (d * DAEMMERUNG * 0.075).toFixed(3);
  }

  // Das Flackern der Flamme in der Laterne.
  //
  // Kein Lichtschalter: eine Flamme steht nie still. Vier Schwingungen mit
  // unrunden Verhaeltnissen — 2,31 / 6,83 / 11,17 / 17,53 je Sekunde —
  // ueberlagern sich zu etwas, das sich nicht wiederholt. Waeren die
  // Verhaeltnisse ganzzahlig, kaeme alle paar Sekunden derselbe Verlauf, und
  // ein Muster ist das, was man an Flackern sofort erkennt.
  //
  // Dazu ein seltenes tieferes Absacken: eine hohe Potenz einer langsamen
  // Schwingung ist die meiste Zeit fast null und faellt nur gelegentlich ein.
  // Kein linearer Kongruenzgenerator — der hat Gitterstruktur (Sackgasse B8).
  // Gemessen ueber 600 s: 0,700 bis 1,189, Mittel 0,980; groesste Aenderung je
  // Bild bei 60 B/s 2,27 %.
  //
  // In der sparsamen Fassung wird das Flackern gedaempft, nicht abgeschaltet.
  // Anders als bei der Stroemung ist es hier sachlich angebracht: die Regel
  // meint vestibulaere Ausloeser, und was davon in Frage kaeme, ist genau
  // schnelles Flackern (Sackgasse F9). Gedaempft bleibt die Laterne ein Feuer,
  // nur ein ruhigeres.
  function flamme(t) {
    var a = Math.sin(t * 2.31 + 0.6) * 0.60
          + Math.sin(t * 6.83) * 0.46
          + Math.sin(t * 11.17 + 1.3) * 0.26
          + Math.sin(t * 17.53 + 2.7) * 0.14;
    var sacken = Math.pow(Math.max(0, Math.sin(t * 0.83 + 1.9)), 10);
    var f = (1 + 0.62 * (a / 1.46)) * (1 - 0.52 * sacken);
    // Spitzen weich stapeln. Roh reicht die Funktion bis 1,617; die Deckkraft
    // eines Elements endet aber bei 1, und ein abgeschnittener Gipfel liest
    // sich als HALTEN statt als Flackern. Die Kennlinie druckt nur oben
    // zusammen und laesst die Taeler unangetastet — und die tragen das
    // Flackern ohnehin staerker als die Spitzen.
    f = f / (1 + Math.max(0, f - 0.85) * 0.92);
    return sparsam ? 1 + (f - 1) * 0.35 : f;
  }

  var lampAlt = -1;
  function setzeLampe(d, t) {
    var f = d > 0.002 ? flamme(t) : 1;
    // Der Kern zuckt voll mit, der Hof deutlich weniger: was ringsum an Wand
    // und Decke ankommt, ist ueber die Streuung geglaettet.
    var kern = d * f;
    // Der Hof folgt jetzt deutlich mehr mit. Bei 38 % war das Zucken auf den
    // Kern beschraenkt, und im Raum blieb das Licht ruhig — es sah aus wie
    // eine Lampe, nicht wie eine Flamme. Ganz mitfuehren waere aber falsch:
    // was ueber Wand und Decke gestreut ankommt, ist immer glatter als die
    // Quelle.
    var hof  = d * (1 + 0.68 * (f - 1));
    if (Math.abs(kern - lampAlt) < 0.0015) return;
    lampAlt = kern;
    var an = DAEMMERUNG > 0 ? 1 : 0;
    if (kernEl)  kernEl.style.opacity  = (kern * an).toFixed(3);
    if (lampeEl) lampeEl.style.opacity = (hof * an).toFixed(3);
  }

  // ================================================================= Zugvoegel
  // Sie ziehen HOCH und SELTEN, in Keilform von rechts nach links. Gezeichnet
  // werden sie zwischen Sonne und Deckplatte `vorn` — dadurch verschwinden sie
  // hinter dem Palmensaum, sobald sie tief genug kommen, ohne dass dafuer
  // gerechnet werden muesste.
  // Zwei Zuege: der Keil hoch oben von rechts nach links, und ein einzelner
  // Vogel auf Minaretthoehe von links nach rechts.
  var ZUEGE = [
    { n: 7, periode: 34, dauer: 13, y: 0.12, gr: 0.011, richtung: -1, versatz: 0.00, deckung: 0.62 },
    { n: 1, periode: 41, dauer: 18, y: 0.36, gr: 0.015, richtung: +1, versatz: 0.42, deckung: 0.50 }
  ];

  function zeichneVoegel(t) {
    ctx.save();
    ctx.strokeStyle = 'rgba(46,34,26,1)';
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    for (var z = 0; z < ZUEGE.length; z++) {
      var Z = ZUEGE[z];
      var u = (((t / Z.periode) + Z.versatz) % 1) * Z.periode / Z.dauer;
      if (u > 1) continue;
      // am Anfang und Ende ausblenden, damit nichts am Fensterrand aufpoppt
      var sicht = glatt(0, 0.10, u) * (1 - glatt(0.90, 1, u));
      if (sicht <= 0.01) continue;
      var yBasis = G.O.y0 + G.O.h * Z.y;
      var rand = G.O.w * 0.22;
      var kx = Z.richtung < 0
        ? misch(G.O.x1 + rand, G.O.x0 - rand, u)
        : misch(G.O.x0 - rand, G.O.x1 + rand, u);
      ctx.globalAlpha = Z.deckung * sicht;
      for (var i = 0; i < Z.n; i++) {
        var k = i - (Z.n - 1) / 2;
        // Keil: die Spitze zeigt in die Flugrichtung
        var px = kx - Z.richtung * Math.abs(k) * G.O.w * 0.035;
        var py = yBasis + k * G.O.h * 0.016 + Math.sin(t * 0.42 + i) * G.O.h * 0.004;
        var gr = G.O.w * Z.gr * G.k;
        // Fluegelschlag: die Oeffnung schwingt, jeder Vogel versetzt
        var schlag = 0.40 + 0.42 * Math.sin(t * 6.2 + i * 1.7 + z * 2.1);
        var x0 = cx(px), y0 = cy(py);
        ctx.lineWidth = Math.max(1, gr * 0.28);
        // Zwei Bogen statt zweier Geraden. Ein Winkel liest sich als Buchstabe;
        // ein Vogel hat gekruemmte Fluegel — aussen aufwaerts, innen leicht
        // durchhaengend.
        ctx.beginPath();
        ctx.moveTo(x0 - gr, y0 - gr * schlag);
        ctx.quadraticCurveTo(x0 - gr * 0.42, y0 + gr * 0.26, x0, y0);
        ctx.quadraticCurveTo(x0 + gr * 0.42, y0 + gr * 0.26, x0 + gr, y0 - gr * schlag);
        ctx.stroke();
      }
    }
    ctx.restore();
  }

  // =================================================================== Sterne
  // Feste Lagen aus einer Streuwertfolge, damit sie ueber die ganze Laufzeit an
  // derselben Stelle stehen. Sie kommen mit der Daemmerung und funkeln leicht.
  // Helligkeitskarte des Raumstreifens, einmal aus der Grundplatte gelesen.
  // Sie sagt, wo der Lichtschaft wirklich liegt — ein Rechteck sagt das nicht.
  var SCHAFT_K = null, SCHAFT_W = 0, SCHAFT_H = 0;
  function bauSchaft() {
    if (!grundImg || !grundImg.naturalWidth) return;
    SCHAFT_W = 72; SCHAFT_H = Math.round(72 * RAUM.h / RAUM.w);
    var c = document.createElement("canvas");
    c.width = SCHAFT_W; c.height = SCHAFT_H;
    var cc = c.getContext("2d");
    cc.drawImage(grundImg, RAUM.x, RAUM.y, RAUM.w, RAUM.h, 0, 0, SCHAFT_W, SCHAFT_H);
    var d = cc.getImageData(0, 0, SCHAFT_W, SCHAFT_H).data;
    SCHAFT_K = new Float32Array(SCHAFT_W * SCHAFT_H);
    for (var i = 0, p = 0; i < SCHAFT_K.length; i++, p += 4)
      SCHAFT_K[i] = 0.2126*d[p] + 0.7152*d[p+1] + 0.0722*d[p+2];
  }
  // 118 ist der gemessene Grenzwert zwischen beschattetem und besonntem
  // Boden; darueber liegt der Schaft.
  function schaftHell(x, y) {
    if (!SCHAFT_K) return 1;
    var u = Math.round((x - RAUM.x) / RAUM.w * (SCHAFT_W - 1));
    var v = Math.round((y - RAUM.y) / RAUM.h * (SCHAFT_H - 1));
    if (u < 0 || v < 0 || u >= SCHAFT_W || v >= SCHAFT_H) return 0;
    return glatt(118, 172, SCHAFT_K[v*SCHAFT_W + u]);
  }

  // Ein Korn, einmal gezeichnet und dann hundertfach gesetzt. Vierhundert
  // Verlaeufe je Bild anzulegen waere spuerbar; ein drawImage ist es nicht.
  var KORN = null;
  function bauKorn() {
    KORN = document.createElement("canvas");
    KORN.width = 16; KORN.height = 16;
    var c = KORN.getContext("2d");
    var g = c.createRadialGradient(8, 8, 0, 8, 8, 8);
    g.addColorStop(0,    "rgba(255,248,226,1)");
    g.addColorStop(0.30, "rgba(255,240,206,0.55)");
    g.addColorStop(1,    "rgba(255,236,198,0)");
    c.fillStyle = g; c.fillRect(0, 0, 16, 16);
  }

  var STERNE = null;
  function bauSterne() {
    STERNE = [];
    for (var i = 0; i < 46; i++) {
      var a = streuwert(i, 11), b = streuwert(i, 29), c = streuwert(i, 53);
      STERNE.push({
        x: G.O.x0 + a * G.O.w,
        // nur im oberen Teil des Fensters — tiefer stuende der Palmensaum davor
        y: G.O.y0 + (0.03 + 0.42 * b * b) * G.O.h,
        h: 0.35 + 0.65 * c,
        f: 1.4 + 3.1 * streuwert(i, 71)
      });
    }
  }
  function streuwert(a, b) {
    var x = Math.sin(a * 12.9898 + b * 78.233) * 43758.5453;
    return x - Math.floor(x);
  }
  function zeichneSterne(t, dae) {
    if (dae <= 0.02 || !STERNE) return;
    ctx.save();
    ctx.globalCompositeOperation = 'lighter';
    for (var i = 0; i < STERNE.length; i++) {
      var s = STERNE[i];
      var funkeln = 0.62 + 0.38 * Math.sin(t * s.f + i * 2.3);
      var a = dae * s.h * funkeln * 0.85;
      if (a < 0.01) continue;
      var r = Math.max(0.6, G.k * (0.7 + 0.5 * s.h));
      var g = ctx.createRadialGradient(cx(s.x), cy(s.y), 0, cx(s.x), cy(s.y), r * 3);
      g.addColorStop(0, 'rgba(255,246,226,' + a.toFixed(3) + ')');
      g.addColorStop(0.4, 'rgba(255,238,208,' + (a * 0.35).toFixed(3) + ')');
      g.addColorStop(1, 'rgba(255,238,208,0)');
      ctx.fillStyle = g;
      ctx.fillRect(cx(s.x) - r * 3, cy(s.y) - r * 3, r * 6, r * 6);
    }
    ctx.restore();
  }

  // ============================================================== Kielwasser
  // Eine schmale Spur, die sich nach hinten oeffnet und verblasst. Sie macht
  // aus einem geschobenen Bild ein fahrendes Boot.
  function zeichneKielwasser(b, t) {
    var L = bootLage(b, t);
    var xm = cx(L.x), ym = cy(L.y);
    var hinten = -b.def.richtung;                    // entgegen der Fahrt
    // Laenger und kraeftiger als im ersten Entwurf. Bei 2,6 Bootsbreiten war die
    // Spur beim Verlassen des Fensters abrupt weg — eine Spur auf Wasser zergeht
    // aber, sie hoert nicht auf. Bei den fernen Booten war sie zudem gar nicht zu
    // sehen, deshalb faellt die Tiefe jetzt weniger ins Gewicht.
    var lang = b.dw * 5.5, dick = b.dh * 0.10 + 1;
    // Am Ende des Umlaufs ausblenden, damit die Spur zergeht statt zu
    // verschwinden. Eine Spur auf Wasser hoert nicht auf, sie loest sich auf.
    var u = ((t / b.def.dauer) + b.def.phase) % 1; if (u < 0) u += 1;
    var a = 0.34 * (0.55 + 0.45 * b.def.tiefe) * (1 - glatt(0.72, 0.99, u));
    ctx.save();
    ctx.globalCompositeOperation = 'lighter';
    var g = ctx.createLinearGradient(xm, 0, xm + hinten * lang, 0);
    g.addColorStop(0, 'rgba(255,232,196,' + a.toFixed(3) + ')');
    g.addColorStop(0.22, 'rgba(255,226,186,' + (a * 0.62).toFixed(3) + ')');
    g.addColorStop(0.55, 'rgba(255,222,178,' + (a * 0.24).toFixed(3) + ')');
    g.addColorStop(1, 'rgba(255,220,176,0)');
    ctx.fillStyle = g;
    ctx.beginPath();
    ctx.moveTo(xm, ym - dick * 0.35);
    ctx.lineTo(xm + hinten * lang, ym - dick * 2.6);
    ctx.lineTo(xm + hinten * lang, ym + dick * 2.6);
    ctx.lineTo(xm, ym + dick * 0.35);
    ctx.closePath();
    ctx.fill();
    ctx.restore();
  }

  // ============================== Der Funke, der auf die Teekanne faellt
  //
  // Ein einzelner Moment, spaet am Abend: aus der Laterne loest sich eine
  // Glut, treibt nach links unten und faellt auf die Kanne. Danach wird die
  // Kanne warm, und ueber dem Ausguss steigt Dampf auf.
  //
  // Gemessen am Raumbild: die Laterne sitzt bei 565 | 215 mit Radius 46, die
  // Kanne steht bei x 240…313, y 1020…1127. Der Weg geht also von 565 | 266
  // nach 272 | 1035.
  var FUNKE_DAUER = 4.6;
  // Gemessen: der Fuss der Kanne steht bei 265 | 1090 auf dem Tablett, der
  // Deckel endet bei rund 1022. Die Glut faellt an den FUSS — dort schlaegt
  // sie auf —, und der Dampf steigt oben aus dem Deckel.
  var FUNKE_VON = { x: 565, y: 266 }, FUNKE_NACH = { x: 265, y: 1090 };
  var KANNE_OBEN = 1022;

  // Wurfparabel statt gerader Bahn.
  //
   // Ein Stueck Glut bricht ab und wird dabei abgestossen: es STEIGT zuerst ein
  // Stueck und faellt dann im Bogen. Der erste Entwurf liess es gleichmaessig
  // sinken — das ist der Fall eines Koerpers, der schon in Ruhe war, und es
  // sah entsprechend aus wie ein herabgelassener Punkt.
  //
  // Aus Scheitelhoehe und Fallhoehe folgen Anfangsgeschwindigkeit und
  // Beschleunigung eindeutig; beide werden hier gerechnet und nicht gesetzt,
  // damit die Glut auch bei anderen Endpunkten genau auf der Kanne landet:
  //   fall(u) = -v0*u + g/2 * u^2 ,  fall(1) = dy ,  Scheitel = v0^2/(2g)
  var FUNKE_SCHEITEL = 48;                       // Bildpunkte, die sie zuerst steigt
  var FUNKE_DY = FUNKE_NACH.y - FUNKE_VON.y;
  var FUNKE_V0 = 2 * FUNKE_SCHEITEL
               + 2 * Math.sqrt(FUNKE_SCHEITEL * FUNKE_SCHEITEL + FUNKE_SCHEITEL * FUNKE_DY);
  var FUNKE_G  = 2 * (FUNKE_DY + FUNKE_V0);

  function zeichneFunke(t, dae, rk) {
    // erst wenn es wirklich Abend ist
    // Sie kann erst abspringen, wenn die Laterne brennt.
    var brennt = glatt(SONNE_DAUER * 0.16, SONNE_DAUER * 0.60, t);
    if (brennt < 0.45) return 0;
    var u = (t - FUNKE_AB) / FUNKE_DAUER;
    if (u < 0) return 0;

    if (u < 1) {
      // Gleichmaessig fallend, nicht beschleunigt. Der erste Entwurf nahm den
      // Exponenten 1,55, also freien Fall — damit sank die Glut anfangs kaum
      // und zog dafuer lange durch den hellen Himmel im Fenster, wo sie sich
      // als Sternschnuppe las. Eine Glut ist aber leicht und hat ihre
      // Endgeschwindigkeit sofort; sie faellt gleichmaessig und kommt so
      // schnell vor den dunklen Raum.
      //
      // Dazu ein Taumeln mit hoeherer Frequenz: ein Meteor zieht gerade, eine
      // Glut trudelt.
      var bahn = function (uk) {
        return [
          misch(FUNKE_VON.x, FUNKE_NACH.x, uk) + Math.sin(uk * 19.4) * 6 * (1 - 0.45 * uk),
          FUNKE_VON.y - FUNKE_V0 * uk + FUNKE_G * 0.5 * uk * uk
        ];
      };
      rctx.globalCompositeOperation = 'lighter';

      // Der Schweif ist eine STRECKE, kein Fleck je Bild.
      //
      // Der erste Entwurf setzte sechs verblassende Kopien an frueheren Lagen —
      // und weil die weit auseinanderliegen, sah es aus wie mehrere Funken in
      // einer Reihe. Genau daran ist in Phase I schon die Lichtspur der Sonne
      // gescheitert: sie zerfiel in einzelne Perlen, und eine Langzeit-
      // belichtung hat keine Luecken. Behoben wurde es dort wie hier — als
      // Strecke vom letzten zum aktuellen Punkt gezeichnet.
      var SCHWEIF = 0.055;
      var u0 = Math.max(0, u - SCHWEIF);
      var pa = bahn(u0), pe = bahn(u);
      var gs = rctx.createLinearGradient((pa[0]-RAUM.x)*rk, (pa[1]-RAUM.y)*rk,
                                         (pe[0]-RAUM.x)*rk, (pe[1]-RAUM.y)*rk);
      gs.addColorStop(0,    'rgba(255,120,40,0)');
      gs.addColorStop(0.45, 'rgba(255,150,64,0.30)');
      gs.addColorStop(1,    'rgba(255,196,124,0.88)');
      rctx.strokeStyle = gs;
      rctx.lineCap = 'round';
      rctx.lineJoin = 'round';
      rctx.lineWidth = Math.max(1.2, rk * 2.6);
      rctx.beginPath();
      for (var k = 0; k <= 14; k++) {
        var p = bahn(u0 + (u - u0) * k / 14);
        if (k === 0) rctx.moveTo((p[0]-RAUM.x)*rk, (p[1]-RAUM.y)*rk);
        else         rctx.lineTo((p[0]-RAUM.x)*rk, (p[1]-RAUM.y)*rk);
      }
      rctx.stroke();

      // Der Kopf: ein einziger, deutlich heller Punkt mit Hof. Er flackert mit
      // derselben Funktion wie die Flamme in der Laterne — es ist dieselbe Glut.
      // Sputtern. Eine fallende Glut brennt ungleichmaessig ab; drei
      // Schwingungen mit unrunden Verhaeltnissen ergeben ein Zucken, das
      // sich in den 4,6 Sekunden des Falls nicht wiederholt.
      var fl = 0.62 + 0.38 * flamme(t * 2.6)
             * (0.72 + 0.28 * Math.sin(t * 23.7 + Math.sin(t * 9.1) * 2.3));
      var hx = (pe[0]-RAUM.x)*rk, hy = (pe[1]-RAUM.y)*rk;

      // Kein runder Hof mehr. Ein weicher Kreis mit gleichmaessigem Abfall ist
      // genau das, was aus der Glut eine Fee gemacht hat — Feuer ist nicht rund
      // und hat keinen sauberen Hof. Stattdessen:
      //   * in Flugrichtung GEZOGEN, so wie eine Kamera eine schnelle Glut
      //     aufzeichnet;
      //   * ein kleiner, sehr heisser Kern statt eines grossen Scheins, und
      //     nach aussen ins Rote statt ins Weisse;
      //   * drei abfallende Stuecke, die zurueckbleiben. Eine bruechige Kohle
      //     verliert beim Fallen Material, und genau daran liest man Feuer.
      var vx = FUNKE_NACH.x - FUNKE_VON.x;
      var vy = -FUNKE_V0 + FUNKE_G * u;
      var wink = Math.atan2(vy, vx);

      rctx.save();
      rctx.translate(hx, hy);
      rctx.rotate(wink);
      // Staerker gezogen und in der Laenge selbst zuckend — eine Flamme hat
      // keine feste Ausdehnung.
      var kr = Math.max(1.6, rk * 4.6) * (0.74 + 0.52 * fl);
      rctx.globalAlpha = 0.62 * fl;
      rctx.drawImage(KORN, -kr * 3.2, -kr * 0.85, kr * 6.4, kr * 1.7);
      // eine zweite, kuerzere und heissere Zunge darueber
      rctx.globalAlpha = 0.50 * fl;
      rctx.drawImage(KORN, -kr * 1.5, -kr * 0.5, kr * 3.0, kr * 1.0);
      rctx.restore();

      var cr = Math.max(1.0, rk * 1.9) * (0.85 + 0.30 * fl);
      var gc = rctx.createRadialGradient(hx, hy, 0, hx, hy, cr * 2.2);
      gc.addColorStop(0,    'rgba(255,236,196,' + (0.98 * fl).toFixed(3) + ')');
      gc.addColorStop(0.30, 'rgba(255,168,66,'  + (0.85 * fl).toFixed(3) + ')');
      gc.addColorStop(0.62, 'rgba(214,64,14,'   + (0.42 * fl).toFixed(3) + ')');
      gc.addColorStop(1,    'rgba(190,60,16,0)');
      rctx.globalAlpha = 1;
      rctx.fillStyle = gc;
      rctx.fillRect(hx - cr*2.2, hy - cr*2.2, cr*4.4, cr*4.4);

      for (var b = 0; b < 6; b++) {
        var bu = u - 0.015 - 0.028 * b;
        if (bu < 0) continue;
        var bp = bahn(bu);
        var bx = (bp[0]-RAUM.x)*rk + (streuwert(b, 13) - 0.5) * 9 * rk * (1 + b) * 0.5;
        var by = (bp[1]-RAUM.y)*rk + streuwert(b, 29) * 5 * rk * 0.5;
        var ba = 0.52 * fl * (1 - b / 6) * (0.35 + 0.65 * streuwert(b, 47));
        var br = Math.max(0.7, rk * (1.7 - 0.20 * b));
        rctx.globalAlpha = ba;
        rctx.drawImage(KORN, bx - br, by - br, br*2, br*2);
      }
      rctx.globalAlpha = 1;

      rctx.globalAlpha = 1;
      return 0;
    }

    // Aufschlag und danach: die Kanne wird warm. Kurzer Blitz, dann bleibt ein
    // Glimmen, das nicht mehr verschwindet.
    var nach = t - (FUNKE_AB + FUNKE_DAUER);
    var blitz = Math.exp(-nach * 3.2);
    var hitze = glatt(0, 7, nach);
    rctx.globalCompositeOperation = 'lighter';
    var gr = rk * (16 + 26 * blitz);
    var g = rctx.createRadialGradient((FUNKE_NACH.x-RAUM.x)*rk, (FUNKE_NACH.y-RAUM.y)*rk, 0,
                                      (FUNKE_NACH.x-RAUM.x)*rk, (FUNKE_NACH.y-RAUM.y)*rk, gr);
    var st = (0.30 * hitze + 0.75 * blitz) * (0.72 + 0.28 * flamme(t * 1.7));
    g.addColorStop(0,    'rgba(255,196,118,' + st.toFixed(3) + ')');
    g.addColorStop(0.35, 'rgba(255,150,72,' + (st * 0.34).toFixed(3) + ')');
    g.addColorStop(1,    'rgba(255,140,64,0)');
    rctx.fillStyle = g;
    rctx.fillRect((FUNKE_NACH.x-RAUM.x)*rk - gr, (FUNKE_NACH.y-RAUM.y)*rk - gr, gr*2, gr*2);
    return hitze;
  }

  // ================================================ Dampf ueber der Kanne
  function zeichneDampf(t, hitze, rk) {
    if (hitze < 0.02) return;
    rctx.globalCompositeOperation = 'lighter';
    var N = sparsam ? 9 : 16;
    for (var i = 0; i < N; i++) {
      var b1 = streuwert(i, 5), b2 = streuwert(i, 31), b3 = streuwert(i, 83);
      var dauer = 3.4 + 2.2 * b3;
      var u = ((t / dauer) + b2) % 1;
      // steigt und verbreitert sich dabei — Dampf zieht sich nicht zusammen
      var breite = 7 + 34 * u;
      var x = FUNKE_NACH.x - 3 + Math.sin(t * (0.7 + 0.5 * b3) + i * 1.9) * breite * 0.55
            + (b1 - 0.5) * 10;
      var y = KANNE_OBEN - 10 - u * 150;
      // unten einblenden, oben verlieren
      var a = hitze * glatt(0, 0.14, u) * (1 - glatt(0.45, 1, u)) * (0.10 + 0.16 * b3);
      if (a < 0.008) continue;
      var rx = Math.max(1.2, rk * (5 + 15 * u));
      var ry = rx * 1.7;
      rctx.globalAlpha = a;
      rctx.drawImage(KORN, (x-RAUM.x)*rk - rx, (y-RAUM.y)*rk - ry, rx*2, ry*2);
    }
    rctx.globalAlpha = 1;
  }

  // ====================================== Staub im Lichtschaft und Funken
  function zeichneRaum(t, dae) {
    if (!rctx || !G.rk) return;
    var rk = G.rk;
    rctx.setTransform(1, 0, 0, 1, 0, 0);
    rctx.clearRect(0, 0, raumEl.width, raumEl.height);
    rctx.globalCompositeOperation = 'lighter';

    // Staub steht nur IM Lichtschaft. Er verschwindet mit der Sonne — ohne
    // Strahl kein Staub, das ist der ganze Effekt.
    var hell = 1 - dae;
    if (hell > 0.02) {
      // Viel mehr und viel feiner als zuvor. 170 Koerner von 2,2 bis 5,6
      // Canvaspunkten lasen sich als wenige helle Flecken; Staub in einem
      // Lichtstrahl ist ein Gewimmel aus winzigen Punkten.
      // Geballt um Tisch und Kanne, nicht ueber den ganzen Boden.
      //
      // Der erste Entwurf koppelte die Deckung an die HELLIGKEIT DES BODENS.
      // Das ist falsch gedacht: Staub schwebt in der Luft, und im Gegenlicht
      // ist er gerade vor DUNKLEM Grund am besten zu sehen — vor der Bank, vor
      // dem Tischfuss. An die Bodenhelligkeit gekoppelt verschwand er genau
      // dort, wo er hingehoert.
      //
      // Gemessen steht die Kanne bei x 240…313, y 1020…1127, die Tischplatte
      // bei x 193…380, y 1117…1153. Die Wolke sitzt darueber.
      var MX = 292, MY = 1105, RX = 185, RY = 250;
      var n = sparsam ? 190 : 430;
      for (var i = 0; i < n; i++) {
        var a1 = streuwert(i, 3), a2 = streuwert(i, 17), a3 = streuwert(i, 41);
        var a4 = streuwert(i, 67);
        // Wurzel der Gleichverteilung: sonst haeuft sich alles in der Mitte.
        var rad = Math.sqrt(a1), wink = a4 * 6.2831853;
        // langsames Sinken mit Umlauf, dazu ein waagerechtes Taumeln. Staub in
        // einem Lichtstrahl faellt nie geradlinig.
        var tempo = 0.010 + 0.024 * a3;
        var v = (a2 + t * tempo) % 1;
        var x = MX + Math.cos(wink) * rad * RX
              + Math.sin(t * (0.17 + 0.28 * a3) + i) * 16;
        var y = MY + (v - 0.5) * 2 * RY;
        // Rand der Wolke weich, und oben wie unten ausblenden
        var e = Math.sqrt(Math.pow((x - MX) / RX, 2) + Math.pow((y - MY) / RY, 2));
        var wolke = 1 - glatt(0.55, 1.0, e);
        var a = hell * wolke * (0.40 + 0.60 * a3);
        if (a < 0.012) continue;
        var r = Math.max(0.6, rk * (0.5 + 1.1 * a3 * a3));
        rctx.globalAlpha = a;
        rctx.drawImage(KORN, (x-RAUM.x)*rk - r, (y-RAUM.y)*rk - r, r*2, r*2);
      }
      rctx.globalAlpha = 1;
    }

    // Der Funke, der auf die Kanne faellt, und der Dampf danach.
    var hitze = zeichneFunke(t, dae, rk);
    zeichneDampf(t, hitze, rk);

    // Funken steigen aus der Laterne, sobald sie brennt. Wenige, kurzlebig.
    if (glatt(SONNE_DAUER * 0.16, SONNE_DAUER * 0.60, t) > 0.05 && D.lampe) {
      var m = sparsam ? 5 : 11;
      var f = flamme(t);
      for (var k = 0; k < m; k++) {
        var b1 = streuwert(k, 7), b2 = streuwert(k, 23), b3 = streuwert(k, 61);
        var dauer = 1.6 + 2.4 * b3;
        var u = ((t / dauer) + b2) % 1;
        // steigen, dabei seitlich taumeln und verloeschen
        var fx = D.lampe.x + (b1 - 0.5) * D.lampe.r * 1.1
               + Math.sin(t * (1.1 + b3) + k) * D.lampe.r * 0.28;
        var fy = D.lampe.y + D.lampe.r * 1.15 - u * D.lampe.r * 2.6;
        var a = dae * (1 - u) * (1 - u) * 0.55 * (0.55 + 0.45 * f);
        if (a < 0.012) continue;
        var r2 = Math.max(0.7, rk * (0.8 + 0.9 * b3));
        var g2 = rctx.createRadialGradient((fx-RAUM.x)*rk, (fy-RAUM.y)*rk, 0,
                                           (fx-RAUM.x)*rk, (fy-RAUM.y)*rk, r2 * 2.4);
        g2.addColorStop(0, 'rgba(255,214,150,' + a.toFixed(3) + ')');
        g2.addColorStop(0.35, 'rgba(255,168,86,' + (a * 0.45).toFixed(3) + ')');
        g2.addColorStop(1, 'rgba(255,150,70,0)');
        rctx.fillStyle = g2;
        rctx.fillRect((fx-RAUM.x)*rk - r2*2.4, (fy-RAUM.y)*rk - r2*2.4, r2*4.8, r2*4.8);
      }
    }
  }

  // ================================================================ Zeichnen
  function zeichne(t) {
    if (!G) return;
    var t1 = performance.now();

    var S = sonneStand(t);
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.globalCompositeOperation = 'source-over';
    ctx.globalAlpha = 1;

    // 1 · Grundplatte, Ausschnitt der Oeffnung. Sie loescht damit zugleich das
    //     vorige Bild — ein eigenes clearRect waere doppelte Arbeit.
    ctx.drawImage(grundImg, G.O.x0, G.O.y0, G.O.w, G.O.h, 0, 0, G.cw, G.ch);

    // 2 · die Sonne, noch ohne Ufer davor
    zeichneSonne(S);

    // 2b · Zugvoegel und Sterne — noch VOR der Deckplatte, damit der
    //      Palmensaum sie verdeckt, sobald sie tief genug stehen.
    var dae = glatt(SONNE_DAUER * 0.55, SONNE_DAUER + 2.2, t);
    zeichneSterne(t, dae);
    zeichneVoegel(t);

    // 3 · Ufer und Wasser zurueck UEBER die Sonne. Damit steht sie dahinter,
    //     und weil der Alphakanal der Deckplatte Punkt fuer Punkt aus der
    //     Helligkeit der Landschaft kommt, scheint sie durch die Luecken
    //     zwischen den Wedeln. In der ersten Machbarkeitsprobe fehlte diese
    //     Ebene ganz, und die Sonne stand VOR den Palmen.
    ctx.drawImage(vorn, 0, 0, G.cw, G.ch);

    // 4 · Lichtsaeule
    zeichneSaeule(S, t);

    // 5 · Spiegelungen — unter den Baendern, damit die Baender sie mitbewegen
    for (var i = 0; i < boote.length; i++) zeichneBoot(boote[i], t, true);

    // 6 · Glanz auf dem Wasser — die Stroemung nach rechts
    zeichneGlanz(t, S);

    // 7 · Kielwasser, dann die Boote selbst. Ueber den Glanzstrichen, damit
    //     ein Boot nicht mitflimmert.
    for (var w = 0; w < boote.length; w++) zeichneKielwasser(boote[w], t);
    for (var j = 0; j < boote.length; j++) zeichneBoot(boote[j], t, false);

    // 8 · der Raum zurueck ueber alles, was ueber die Fensterkante lief
    ctx.drawImage(rahmen, 0, 0, G.cw, G.ch);

    // Daemmerung faengt an, wenn die Sonne den Saum erreicht, und laeuft noch
    // ein Stueck weiter, nachdem sie verschwunden ist.
    setzeDaemmerung(dae);
    // Die Laterne wird ANGEZUENDET, bevor es dunkel ist — man wartet damit
    // nicht, bis man nichts mehr sieht. Eigene, deutlich fruehere Kurve; damit
    // ist sie schon brennend, wenn die Glut abspringt.
    var lampe = glatt(SONNE_DAUER * 0.16, SONNE_DAUER * 0.60, t);
    setzeLampe(Math.max(lampe, dae), t);
    zeichneRaum(t, dae);

    if (P.has('raster')) zeichneRaster();

    window.__arc.t = Math.round(t * 1000) / 1000;
    window.__arc.p = Math.round(S.u * 1000) / 1000;      // 0 Sonne oben … 1 unten
    window.__arc.sonne = { x: Math.round(S.x), y: Math.round(S.y), r: Math.round(S.r) };
    window.__arc.baum = baumBei(S.x);
    window.__arc.sparsam = sparsam;   // sichtbar machen, welche Fassung laeuft
    // „feuer" heisst im Vertrag der Werkzeuge die Lichtquelle der Szene, in
    // Koordinaten des Abschnitts. Hier ist das die Sonne. groessen.mjs prueft
    // damit, ob sie auf jeder Fenstergroesse mit Luft im Bild steht.
    window.__arc.feuer = {
      x: Math.round(G.bx + S.x * G.s),
      y: Math.round(G.by + S.y * G.s)
    };
    // Lage der Boote in Plattenkoordinaten, damit die Werkzeuge pruefen
    // koennen, ob sie im Bild stehen und ob sie auf dem Wasser sitzen.
    window.__arc.boote = boote.map(function (b) {
      var L = bootLage(b, t);
      return {
        x: Math.round(L.x), y: Math.round(L.y),
        w: b.dw, h: b.dh,                       // in CANVASpunkten
        richtung: b.def.richtung,
        im: L.x > G.O.x0 && L.x < G.O.x1
      };
    });
    // Die Bildrate ist in einem ferngesteuerten Browser nicht messbar — er
    // taktet requestAnimationFrame fest und meldet immer 10 ms. Was zaehlt, ist
    // die Rechenzeit je Bild und vor allem die FLAECHE.
    var dt = performance.now() - t1;
    window.__arcTempo.n++;
    window.__arcTempo.summe += dt;
    if (dt > window.__arcTempo.max) window.__arcTempo.max = dt;
    window.__arcTempo.mp = Math.round(G.cw * G.ch / 1e4) / 100;
  }

  function zeichneRaster() {
    ctx.save();
    ctx.lineWidth = Math.max(1, G.k);
    ctx.strokeStyle = 'rgba(255,0,255,0.9)';
    ctx.beginPath();
    for (var i = 0; i < D.wasserlinie.length; i++) {
      var x = cx(G.O.x0 + i), y = cy(D.wasserlinie[i]);
      if (i === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
    }
    ctx.stroke();
    ctx.strokeStyle = 'rgba(0,255,255,0.9)';
    ctx.beginPath();
    for (var k = 0; k < D.baumlinie.length; k++) {
      var bx = cx(G.O.x0 + k), by = cy(D.baumlinie[k]);
      if (k === 0) ctx.moveTo(bx, by); else ctx.lineTo(bx, by);
    }
    ctx.stroke();
    ctx.restore();
  }

  // ================================================================== Schleife
  function schleife() {
    if (!laeuft) return;
    zeichne((performance.now() - t0) / 1000);
    requestAnimationFrame(schleife);
  }

  function start() {
    if (angehalten !== null) { zeichne(angehalten); return; }
    if (laeuft) return;
    laeuft = true;
    t0 = performance.now();
    planeKarten();
    requestAnimationFrame(schleife);
  }

  // ==================================================================== Laden
  Promise.all([
    window.MB_FENSTER_DATEN
      ? Promise.resolve(window.MB_FENSTER_DATEN)
      : fetch(Q.daten).then(function (r) { return r.json(); }),
    grundImg.complete && grundImg.naturalWidth
      ? Promise.resolve(grundImg)
      : new Promise(function (f, s) { grundImg.onload = function () { f(grundImg); }; grundImg.onerror = s; }),
    bild(Q.vorn),
    bild(Q.rahmen),
    bild(Q.boot1),
    bild(Q.boot2),
    bild(Q.boot3)
  ]).then(function (a) {
    D = a[0]; vorn = a[2]; rahmen = a[3];
    bootPlatten = [a[4], a[5], a[6]];
    window.__arc.platten = 6;
    window.__arc.vollstaendig = true;

    rechneGeometrie();
    window.addEventListener('resize', function () {
      rechneGeometrie();
      if (angehalten !== null) zeichne(angehalten);
    });

    // Von aussen setzbare Uhr. Die Aufnahme braucht genau bestimmte
    // Zeitpunkte; ueber ?t= ginge das nur mit einem Neuladen je Bild, und das
    // waere bei 1650 Bildern eine halbe Stunde.
    window.__arcZeit = function (t) { laeuft = false; angehalten = t; zeichne(t); };

    if (FILM) {
      var h = document.querySelector('.mb-passage__hinweis');
      if (h) h.style.display = 'none';
      document.body.style.overflow = 'hidden';
    }

    if (P.has('t')) {
      angehalten = Number(P.get('t'));
      zeichne(angehalten);
      if (angehalten >= 5) zeigeKarten();
      return;
    }

    // Im Theme-Editor wird wie bei den anderen Phasen direkt der editierbare
    // Endzustand gezeigt. Auf der echten Seite gilt die Startverzoegerung.
    if (window.Shopify && window.Shopify.designMode) zeigeKarten();

    // Erst starten, wenn die Szene wirklich zu sehen ist.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (e) {
        if (e[0].isIntersecting) { start(); io.disconnect(); }
      }, { threshold: 0.15 });
      io.observe(abschnitt);
    } else start();
  }).catch(function (e) {
    console.error('[arc-of-passage]', e);
  });
})();
